(() => {
  if (window.collectionPhotoSwatchesLoaded) return;
  window.collectionPhotoSwatchesLoaded = true;
  function update(root) {
    root.querySelectorAll('[data-model-options], [data-catalog-options]').forEach(control => {
      const catalog = control.hasAttribute('data-catalog-options');
      const source = control.querySelector(catalog ? '[data-catalog-variants]' : '[data-model-products]');
      let choices = [];
      try { choices = JSON.parse(source?.textContent || '[]'); } catch { return; }
      control.querySelectorAll('.model-options__swatch:not(.collection-photo-swatch)').forEach(button => {
        let matches;
        if (button.hasAttribute('data-catalog-color')) {
          matches = choices.filter(choice => choice.options[Number(button.dataset.catalogIndex)] === button.dataset.catalogColor);
        } else if (button.hasAttribute('data-model-color')) {
          matches = choices.filter(choice => choice.color === button.dataset.modelColor);
        } else {
          matches = [];
        }
        const choice = matches.find(choice => choice.available && choice.image) || matches.find(choice => choice.image);
        const fallback = !button.hasAttribute('data-catalog-color') && !button.hasAttribute('data-model-color')
          ? control.closest('.grid-product')?.querySelector('.product-image-frame img')
          : null;
        const src = choice?.image || fallback?.currentSrc || fallback?.src;
        if (!src) return;
        const url = new URL(src, location.origin);
        url.searchParams.set('width', '112');
        const image = document.createElement('img');
        image.src = url.href;
        image.alt = '';
        image.width = 48;
        image.height = 56;
        image.loading = 'lazy';
        image.decoding = 'async';
        button.classList.add('collection-photo-swatch');
        button.classList.remove('catalog-card-options__text-swatch');
        button.replaceChildren(image);
      });
    });
  }
  function init() {
    update(document);
    let scheduled = false;
    new MutationObserver(records => {
      if (scheduled || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-model-options], [data-catalog-options]') || node.querySelector?.('[data-model-options], [data-catalog-options]'))))) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; update(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
